module.exports = __webpack_public_path__ + "img/sms.59b25fb1.png";